import form from "@/lib/form";

export default {
  dashboard: {
    colors: {
      absent: {
        class: 'c-exercise-pass__exercise--other',
        color: '#999',
        label: 'absent/reserve'
      },
      dns: {
        class: 'c-exercise-pass__exercise--dns',
        color: '#666',
        label: 'dns'
      },
      dnf: {
        class: 'c-exercise-pass__exercise--dnf',
        color: 'blue',
        label: 'dnf'
      },
      finished: {
        class: 'c-exercise-pass__exercise--finished',
        color: 'blue',
        label: 'finished'
      },
      open: {
        class: 'c-exercise-pass__exercise--active',
        color: 'orange',
        label: 'open'
      },
      scheduled: {
        class: 'c-exercise-pass__exercise--scheduled',
        color: 'red',
        label: 'scheduled'
      },
      missing: {
        class: 'c-exercise-pass__exercise--other',
        color: 'white',
        label: 'missing'
      },
      filler: {
        class: 'c-exercise-pass__exercise--filler',
        color: 'white',
        label: 'filler'
      }
    },
  },
  organisation: {
    liveScoreOptions: form.idNamePairs(['GymFed', 'FfGym', 'KNGU'], ''),
    roleOptions: form.idNamePairs(['admin', 'organiser'], 'role.'),
  },
  eventDiscipline: {
    liveScoreOptions: form.idNamePairs(['none', 'publicAPI', 'ScoreExpress', 'KNGU'], 'publicationMethod.'),
    liveScoreSchedule: form.idNamePairs(['none', 'timetable', 'startingOrder', 'exerciseTime'], 'liveScore.schedule.'),
    clubSymbolsOptions: form.idNamePairs(['flags', 'region'], 'clubSymbol.'),
    judgeRepresentationOptions: form.idNamePairs(['none', 'club', 'country'], 'judgeRepresentation.'),
    groupDisplay: form.idNamePairs(['members', 'group'], 'groupDisplay.'),
    teamDisplay: form.idNamePairs(['team', 'club', 'club-team'], 'teamDisplay.'),
    finalsReports: form.idNamePairs(['regular', 'combined'], 'discipline.finalsReports.'),
    awardOrder: form.idNamePairs(['awardBib' , 'awardClub', 'bib', 'name', 'clubName'], "awardOrder."),
  },
  category: {
    genderOptions: form.idNamePairs(['male', 'female', 'mixed'], 'gender.'),
    participantTypeOptions: form.idNamePairs(["clubMember", "group"], 'participantType.'),
    scorePublicationOptions: form.idNamePairs(['totals', 'full', 'none'], 'scorePublication.'),
    rankingPublicationOptions: form.idNamePairs(['full', 'awards', 'none'], 'rankingPublication.'),
    teamMethodOptions: form.idNamePairs(['event', 'AA', 'exercises'], 'category.teamMethod.'),
    roundResultOptions: form.idNamePairs(['reset', 'add'], 'final_result.'),
    awardTypes: form.idNamePairs(['score', 'ranking_percentage', 'subdivision_percentage', 'result'], 'awardType.'),
    trackSelection: form.idNamePairs(['allRequired', 'oneRequired'], 'categoryRound.trackSelection.requirementsCheck.')
  },
  session: {
    orderTypes: form.idNamePairs(['block', 'rotation', 'mixed'], 'session.orderType.'),
    rotationTypes: form.idNamePairs(['fixed', 'alternating', 'schedule'], 'session.rotationType.'),
    timeTableItems: form.idNamePairs(
      ['judgemeeting', 'warmupStart', 'marchin', 'competition', 'ceremony', 'end'], 'session.schedule.'),
  },
  participation: {
    statusOptions: form.idNamePairs(['present', 'absent', 'reserve', 'not-selected'], 'participation.status.'),
  },
  planning: {
    groupByClub: form.idNamePairs(['mixClubs', 'groupClubs'], 'planning.groupOption.'),
    groupByCategory: form.idNamePairs(['horizontal', 'vertical'], 'planning.groupOption.'),
    blockTimeType: form.idNamePairs(['byCount', 'fixed'], 'planning.blockTime.'),
    orderPrinciples: form.idNamePairs(['random', 'repeat', 'rotate'], 'planning.orderPrinciple.'),
  },
  warmup: {
    types: form.idNamePairs(['regular','scheduled'], ''),
  }
}
